import { createSlice } from "@reduxjs/toolkit";
import { get_valut_data_by_username_thunk, get_valut_data_thunk, update_vault_data_thunk, updateVaultColorFocus } from "./vaultdataThunk";

const initialState = {
    headerTitle: '',
    title: '',
    description: '',
    image: '',
    background: '',
    accent: '',
    grayscale: '',
    noise: '',
    musicList: [],
    isImageOverlay: false,
    curPlayStreamData: null,
}

const slice = createSlice({
    name: "vaultData",
    initialState,
    reducers: {
        setVaultData: (state, action) => {
            let { background, grayscale, noise, accent } = action.payload;
            state.background = background
            state.noise = noise
            state.accent = accent
            state.grayscale = grayscale
            console.log(`action.payload::`, action.payload);
        },
        updateHeaderTitle: (state, action) => {
            state.headerTitle = action.payload
        },
        updateTitle: (state, action) => {
            state.title = action.payload
        },
        updateDescription: (state, action) => {
            state.description = action.payload
        },
        updateImage: (state, action) => {
            state.image = action.payload
        },
        updateImageOverlay(state, action) {
            state.isImageOverlay = action.payload
        },
        updateCurPlayStreamData(state, action) {
            state.curPlayStreamData = action.payload
        },
        clearVault: (state) => {
            state.title = ''
            state.description = ''
            state.image = ''
            state.musicList = []
        }
    },
    extraReducers: (builder) => {

        builder
            .addCase(get_valut_data_thunk.pending, (state) => {
                console.log(`get_valut_data_thunk pending`)
            })
            .addCase(get_valut_data_thunk.fulfilled, (state, action) => {
                console.log(`vault data thunk..`, action.payload)
                let { headerTitle, title, description, image, musicList, background, accent, noise, grayscale } = action.payload
                state.headerTitle = headerTitle;
                state.title = title;
                state.description = description;
                state.image = image;
                state.musicList = musicList;
                state.background = background ? background : '';
                state.accent = accent ? accent : '';
                state.noise = noise ? noise : '';
                state.grayscale = grayscale ? grayscale : '';
            })
            .addCase(get_valut_data_thunk.rejected, (state, action) => {
                state.headerTitle = '';
                state.title = '';
                state.description = '';
                state.image = null;
                state.musicList = [];
                console.log(`get_valut_data_thunk failed--`, state)
            });


        builder
            .addCase(updateVaultColorFocus.pending, (state) => {
                console.log(`updateVaultColorFocus pending`)
            })
            .addCase(updateVaultColorFocus.fulfilled, (state, action) => {
                console.log(`vault data thunk..`, action.payload.data.data)
                let { background, accent, noise, grayscale } = action.payload.data.data
                state.background = background ? background : '';
                state.accent = accent ? accent : '';
                state.noise = noise ? noise : '';
                state.grayscale = grayscale ? grayscale : '';
            })
            .addCase(updateVaultColorFocus.rejected, (state, action) => {
                state.headerTitle = '';
                state.title = '';
                state.description = '';
                state.image = null;
                state.musicList = [];
                console.log(`updateVaultColorFocus failed--`, state)
            });

        builder.addCase(get_valut_data_by_username_thunk.pending, (state) => {
            state.loading = true;
            state.error = null;
            console.log(`get_valut_data_by_username_thunk pending`)
        }).addCase(get_valut_data_by_username_thunk.fulfilled, (state, action) => {
            let { headerTitle, title, description, image, musicList, background, noise, grayscale, accent } = action.payload
            state.headerTitle = headerTitle;
            state.title = title;
            state.description = description;
            state.image = image;
            state.musicList = musicList;
            state.background = background ? background : '';
            state.accent = accent ? accent : '';
            state.noise = noise ? noise : '';
            state.grayscale = grayscale ? grayscale : '';
        }).addCase(get_valut_data_by_username_thunk.rejected, (state, action) => {
            console.log(`get_valut_data_by_username_thunk failed`)
            state.loading = false;
            state = initialState
            state.error = action.payload || 'Redux Cases Error'
        })

        builder.addCase(update_vault_data_thunk.pending, (state) => {
            state.loading = true;
            state.error = null;
            console.log(`update_vault_data_thunk pending`)
        }).addCase(update_vault_data_thunk.fulfilled, (state, action) => {
            let { headerTitle, title, description, image, musicList, background, noise, grayscale, accent } = action.payload
            state.headerTitle = headerTitle;
            state.title = title;
            state.description = description;
            state.image = image;
            state.musicList = musicList;
            state.background = background ? background : '';
            state.accent = accent ? accent : '';
            state.noise = noise ? noise : '';
            state.grayscale = grayscale ? grayscale : '';
        }).addCase(update_vault_data_thunk.rejected, (state, action) => {
            console.log(`update_vault_data_thunk failed`)
            state.loading = false;
            state.error = action.payload || 'Redux Cases Error'
        })
    }
})

export const { updateHeaderTitle, updateTitle, updateDescription, setVaultData,
    updateCurPlayStreamData,
    updateImageOverlay, updateImage, clearVault } = slice.actions;

export default slice.reducer;